"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import { FaGithub } from "react-icons/fa"

// Props: ProjectCard (child) receives project data (props)
const ProjectCard = ({ project, onProjectClick }) => (
  <motion.div 
    className="proj-card relative p-6 z-20 rounded-xl bg-[#091121] border border-cyan-500/70 hover:border-pink-400 hover:shadow-xl transition-colors duration-300 shadow-md flex flex-col justify-between cursor-pointer"
    onClick={() => onProjectClick(project)}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: false, amount: 0.25 }}
    transition={{ duration: 0.45, ease: "easeOut" }}
    variants={{
      hidden: { opacity: 0, y: 22, rotate: 0.25 },
      visible: { opacity: 1, y: 0, rotate: 0 }
    }}
    whileHover={{ y: -6 }}
  >

    {project.image ? (
      <div className="w-full h-48 md:h-56 mb-4 rounded-lg overflow-hidden flex items-center justify-center bg-gray-200">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover object-top"
        />
      </div>
    ) : (
      <div className="w-full h-40 mb-4 rounded-lg overflow-hidden bg-gray-300 flex items-center justify-center text-gray-500 text-sm">
        Project Image
      </div>
    )}

    <div>
      <h3 className="text-xl font-semibold text-cyan-500 mb-2">{project.title}</h3>
      <p className="proj-desc text-muted-foreground text-justify mb-4 text-sm md:text-base">{project.description}</p>
    </div>

    <div className="mt-4 flex flex-col gap-3 items-start">
      <div className="flex flex-wrap gap-2">
        {project.technologies.map((tech, idx) => (
          <span
            key={idx}
            className="proj-pill px-3 py-1 text-gray-200 border border-cyan-500 rounded-full text-xs md:text-sm cursor-default
                      transition-transform duration-200 hover:-translate-y-1"
          >
            {tech}
          </span>
        ))}
      </div>

      <a
        href={project.github || "#"}
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-full bg-gray-800 text-white text-base md:text-lg flex items-center justify-center hover:bg-gray-700 transition-colors"
        aria-label="GitHub Repository"
      >
        <FaGithub />
      </a>
    </div>

  </motion.div>
)

// Parent 
// Nandito yung mga projects data
// So meron tayong child component na ProjectCard (nasa taas):
    // ginagamit natin yun as child as format na lalagyan ng data
    // then yung data is from the parent (Projects) na ilalagay sa ProjectCards
const Projects = () => { // rerender (php)
  // State: Filter state for project filtering
  // so state selectedFilter (current filter) - "to determine kung anong filter ang active"
  // then yung setSelectedFilter is tinatawag sa pagchange ng filter - "to update the filter"

  // nagsisimula yun gamit yung event handler na handleFilterChange (proceed sa fnction)
  const [selectedFilter, setSelectedFilter] = useState("all") // matic default
  const [projects] = useState([
    {
      id: 1,
      title: "Color Game",
      description: "Developed an engaging Java color-matching game featuring three levels of difficulty—easy, medium, and hard—each with varying numbers of dice and colors for betting. This project uses the power of Java Swing for visually appealing graphics.",
      technologies: ["Java"],
      github: "https://github.com/Je-ric",
      image: process.env.PUBLIC_URL + "/img/colorgame.png",
    },
    {
      id: 2,
      title: "BeatStrum",
      description: "Developed BeatStrum, an e-commerce website for musical instruments, using an object-oriented programming approach. The project features a user-friendly interface, categorized listings, and efficient product management.",
      technologies: ["HTML", "CSS", "PHP", "JavaScript", "MySQL", "AJAX"],
      github: "https://github.com/Je-ric",
      image: process.env.PUBLIC_URL + "/img/BeatStrum.png",
    },
    {
      id: 3,
      title: "CBAA Front-End Website",
      description: "Developed a responsive website for the College of Business Administration and Accountancy (CBAA), emphasizing front-end development practices. The website effectively outlines the college's programs, courses, and faculty and staff while ensuring seamless viewing across various devices, enhancing user experience and accessibility.",
      technologies: ["HTML", "CSS", "JavaScript"],
      github: "https://github.com/Je-ric",
      image: process.env.PUBLIC_URL + "/img/cbaa.png",
    },
    {
      id: 4,
      title: "Concert Reservation System",
      description: "Built a Concert Reservation System using Object-Oriented Programming, featuring user-friendly interfaces for both administrators and attendees. Users can effortlessly browse available concerts, reserve specific seats, receive email notifications, utilize various payment methods, and easily cancel reservations.",
      technologies: ["HTML", "CSS", "PHP", "JavaScript", "MySQL", "AJAX"],
      github: "https://github.com/Je-ric",
      image: process.env.PUBLIC_URL + "/img/Concert.png",
    },
    {
      id: 5,
      title: "Student Portal",
      description: "Introducing a comprehensive Student Portal system built on Object-Oriented Programming principles. Seamlessly manage grading systems, update student records, and empower administrators with efficient information modification, all through intuitive interfaces tailored for both students and administrators.",
      technologies: ["HTML", "CSS", "PHP", "JavaScript", "MySQL"],
      github: "https://github.com/Je-ric",
      image: process.env.PUBLIC_URL + "/img/StudentPortal.png",
    },
    {
      id: 6,
      title: "Job Application Form",
      description: "Designed a dynamic job application form with interactive fields allowing applicants to easily modify and update their submissions. Built functionality for administrators to review and manage applications, including the ability to delete redundant entries, simplifying the recruitment process effectively.",
      technologies: ["HTML", "CSS", "PHP", "JavaScript", "MySQL"],
      github: "https://github.com/Je-ric",
      image: process.env.PUBLIC_URL + "/img/jobs.png",
    },
  ])

  // Event handling: Filter change handler
  // kinukuha yung value ng key na pinindot sa filterOptions
  const handleFilterChange = (filter) => {
    setSelectedFilter(filter) // (php)
    console.log('Filter changed to:', filter)
  }

  // Event handling: Project click handler
  const handleProjectClick = (project) => {
    console.log('Project clicked:', project.title)
  }

  // filter based sa selectedFilter (php)
  // niloloop yung projects array
  // then chinecheck every project if yung technologies (array) may match sa selectedFilter
  // by default, ito yung una to render
  
  // sunod toh
  // REMEMBER: every reload or click sa filter, nagrerender ulit to
  // thats why we didnt know when, we just know na pag nasa handleFilterChange, magrere-render to
  const filteredProjects = selectedFilter === "all" 
    ? projects 
    : projects.filter(project => 
        project.technologies.some(tech => 
          tech.toLowerCase().includes(selectedFilter.toLowerCase()) // para case insensitive
        )
      )

  const filterOptions = ["all", "java", "php", "html", "css", "javascript", "mysql", "ajax"]

  return (
    <section id="projects" className="min-h-screen py-12 my-12 px-4 md:px-8 lg:px-12">
      <div className="container mx-auto">
        <h2 className="font-bold mb-6 pb-6 text-center">A few of my personal and academic projects where I'm practicing coding, experimenting with new tools,
          and improving my development skills.
          You can see the technologies I used and view the code on GitHub.
        </h2>
        
        {/* Filter buttons */}
        <motion.div 
          className="flex flex-wrap justify-center gap-2 mb-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.25 }}
          transition={{ duration: 0.4 }}
          variants={{ hidden: { opacity: 0, y: 10 }, visible: { opacity: 1, y: 0 } }}
        >
          {filterOptions.map((filter) => (
            <button
              key={filter}  
              /* Basta nasa filterOptions, matic may button, then pag click nakukuha yung value sa key na pinapasa sa handler
                na ginagamit as filter */
              onClick={() => handleFilterChange(filter)} /* Ex. handleFilterChange('php') passed to handler */
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                selectedFilter === filter /* current state */ 
                  ? 'bg-cyan-500 text-white shadow-lg'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              }`}
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)} {/* Pang capital */}
            </button>
          ))}
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Props: Passing project data and click handler to ProjectCard */}
          {filteredProjects.map((project) => (
            <ProjectCard 
              key={project.id} 
              project={project} 
              onProjectClick={handleProjectClick}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Projects
